export const CONTRACT = 'contract';
export const DOCUMENTATION = 'documentation';
export const OFFER = 'offer';
export const VISIT = 'visit';

export default Object.freeze({
  CONTRACT,
  DOCUMENTATION,
  OFFER,
  VISIT,
});
